import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import md5 from "js-md5";
import { object, string } from 'yup';

import Cookies from "universal-cookie";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";

import { fetchApi } from "../tools";
import Layout from "../Layout";
import Header from "../components-layout/Header";
import Container from "../components-layout/Container";
import WarningModal from "../components-modals/WarningModal";
import { KeyIcon, EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { CambioConInstrucciones } from "./ui-components/CambioConInstrucciones";
import Commander from "./api/Comandos";

export const CambioConIndex = () => {
  const user = useSelector((state) => state.auth.user);
  const JSONuser = JSON.parse(user);
  console.log('JSONuser: ', JSONuser)
  const IdEmp = useSelector((state) => state.auth.IdEmp);
  const userObj = JSON.parse(user);

  userObj.LoginId = userObj.LoginId.split(" ")
    .map((x) => {
      return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
    })
    .join(" ");

  const cookies = new Cookies();
  const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
  const urlSeguridad = cookies.get("__urlSeguridad");
  const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux

  //const options = useOptions(url, headers); // Sedes

  const [loading, setLoading] = useState(false);
  const [passFromRedux, setPassFromRedux] = useState(JSONuser.password);

  const [colors, setColors] = useState({
    color1: " bg-gray-500 ",
    color2: " bg-gray-500 ",
    color3: " bg-gray-500 ",
  });

  //Manejo de errores
  const [modal, setModal] = useState({
    show: false,
    msg: "",
    ok: false,
  });
  const [showPswd0, setShowPswd0] = useState(false);
  const [showPswd1, setShowPswd1] = useState(false);
  const [showPswd2, setShowPswd2] = useState(false);

  const togglePswd0 = () => {
    return setShowPswd0(!showPswd0);
  };

  const togglePswd1 = () => {
    return setShowPswd1(!showPswd1);
  };

  const togglePswd2 = () => {
    return setShowPswd2(!showPswd2);
  };

  const topRef = useRef(null);
  const contenidoGrid = null;
  const [cactual, setCactual] = useState("");

  const enviarInfo = async (info, values) => {
    const response = await Commander.run('SavePassword', urlSeguridad, "/seguridad/cambiopassword", headers, fetchApi, info)
    
    setModal({
      show: true,
      msg: response.msg[0].Mensaje,
      ok:  response.msg[0].Error ? false : true,
    });
    
    values.CActual = !response.msg[0].Error ? values.CActual = "" : values.CActual;
    values.CNueva =  !response.msg[0].Error ? values.CNueva  = "" : values.CNueva;
    values.CNueva2 = !response.msg[0].Error ? values.CNueva2 = "" : values.CNueva2;
    
  };

  const submit = (values, errors, indice) => {
    let valores = values ;
    //let AnteriorMD5 = valores.CActual;
    //let NuevaMD5    = valores.CNueva;
    let AnteriorMD5 = md5(valores.CActual) // al tener la api modificada, funciona
    let NuevaMD5    = md5(valores.CNueva)
    let contenido = {
      Anterior: AnteriorMD5,
      Nueva: NuevaMD5,
      LoginId: userObj.LoginId,
      IdEmp: IdEmp,
      HostName: "DEV1",
      IpHost: "131.107.1.239",
      NombreBrowser: "Windows / Chrome 10",
    };
    enviarInfo(contenido, values);
  };

  const handleLocal = (e, setFieldValue, index, errors) => {
    setFieldValue(e.target.name, e.target.value);
    switch (index) {
      case 1:
        //setCactual(md5(e.target.value));
        setCactual(e.target.value);
        break;
      case 2:
        if (!errors.CNueva) {
          setColors({ ...colors, color2: "bg-green-500" });
        } else {
          setColors({ ...colors, color2: "bg-gray-500" });
        }
        break;
      case 3:
        if (!errors.CNueva2) {
          setColors({ ...colors, color3: "bg-green-500" });
        } else {
          setColors({ ...colors, color3: "bg-gray-500" });
        }
        break;
      default:
        break;
    }
  };

  const handleBlur = (e, index, values) => {
    switch (index) {
      case 1:
        const actualmd5 = values.CActual
        console.log(actualmd5)
        console.log(passFromRedux )
        if ( actualmd5 !== passFromRedux ) {
          setColors({
            ...colors,
            color1: "bg-gray-500",
          });
          setModal({
            show: true,
            msg: "La contraseña ingresada no corresponde a la actual, intente de nuevo",
            ok: false,
          });
        } else {
          setColors({
            ...colors,
            color1: "bg-green-500",
          });
        }
        setColors({
          ...colors,
          color1: "bg-green-500",
        });
        break;
      case 3:
        if (
          values.CNueva2 !== values.CNueva ||
          (values.CNueva === "" && values.CNueva2 === "")
        ) {
          setColors({
            ...colors,
            color2: "bg-gray-500",
            color3: "bg-gray-500",
          });
          setModal({
            show: true,
            msg: "Las contraseñas nuevas no coinciden , intente de nuevo",
            ok: false,
          });
        } else {
          setColors({
            ...colors,
            color2: "bg-green-500",
            color3: "bg-green-500",
          });
        }
        break;

      default:
        break;
    }
  };

  const initialValues = {
    CActual: "",
    CNueva:  "",
    CNueva2: "",
  };
  
  const validationSchema = object({
    CNueva: 
    string()
    .matches(/[0-9]+/, "Debe contener al menos un número")
    .matches(/^\S*$/, "No debe contener espacios")
    .min(6, "Al menos debe tener 6 caracteres")
    .max(30, "No debe tener más de 30 caracteres"),
    CNueva2: 
    string()
    .matches(/[0-9]+/, "Debe contener al menos un número")
    .matches(/^\S*$/, "No debe contener espacios")
    .min(6, "Al menos debe tener 6 caracteres")
    .max(30, "No debe tener más de 30 caracteres"),
  });
  
  /*
  useEffect(() => {
    if ( md5(cactual) === passFromRedux ) {
      console.log("iguales", cactual, passFromRedux);
    }
  }, [cactual]);*/

  return (
    <>
      <Layout userObj={userObj} activeTab="Cambio de contraseña">
        <Container height="h-full">
          <Header title="Cambiar Contraseña" logo={KeyIcon} />
          <WarningModal
            open={loading ? true : false}
            image={<img src="./img/loader.gif" alt="loading" />}
            opacity="bg-opacity-100"
          />
          <WarningModal
            open={modal.show ? true : false}
            image={
              modal.ok ? (
                <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
              ) : (
                <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
              )
            }
            title="Aviso"
            subtitle={<span>{modal.msg}</span>}
            opacity="bg-opacity-50"
          >
            <div className="mt-5 sm:mt-6">
              <button
                onClick={() => {
                  if (modal.reload) {
                    window.location.reload();
                  }
                  setModal((curr) => ({
                    ...curr,
                    show: false,
                    reload: false,
                  }));
                }}
                type="button"
                className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >
                Entendido
              </button>
            </div>
          </WarningModal>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            //onSubmit={(values) => handleSubmit(values)}
          >
            {({ setFieldValue, values, resetForm, errors, touched }) => {
              // console.log("VALUES:", values)
              // console.log("ERRORS:", errors)
              return (
                <Form>
                  <div className="lg:flex lg:flex-row sm:flex sm:flex-col">
                    <div className="basis-1/4"></div>

                    <div className="basis-1/2">
                      <div className=" lg:flex lg:flex-row rounded-lg bg-primarioMira p-y-6">
                        
                        <div className=" w-[100%] gap-x-6 gap-y-2 p-3">

                          <label
                            field="CActual"
                            className=" text-white"
                          >
                            Contraseña Actual
                          </label>
                           <div className=" bg-white rounded-md flex flex-row shadow-sm focus:border-secundario focus:ring-secundario">
                            <Field
                              onChange={(e) =>
                                handleLocal(e, setFieldValue, 1, errors)
                              }
                              onBlur={(e) => {
                                handleBlur(e, 1, values);
                              }}
                              type={ showPswd0 ? "text":"password" }
                              name="CActual"
                              className="rounded-md border-white shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm  basis-11/12"
                            ></Field>
                            <div className="ml-2 mt-2 hover:text-secundario">
                            {showPswd0 ? (
                              <EyeSlashIcon
                                className=" w-6 h-6 basis-1/12 "
                                onClick={()=>togglePswd0()}
                              />
                            ) : (
                              <EyeIcon
                                className="  w-6 h-6 basis-1/12 "
                                onClick={()=>togglePswd0()}
                              />
                            )}
                            </div>
                          </div>

                          <label
                            field="CNueva"
                            className=" text-white"
                          >
                            Contraseña Nueva
                          </label>
                          <div className=" bg-white rounded-md  flex flex-row shadow-sm focus:border-secundario focus:ring-secundario">
                            <Field
                              onChange={(e) =>
                                handleLocal(e, setFieldValue, 2, errors)
                              }
                              onBlur={(e) => {
                                handleBlur(e, 2, values);
                              }}
                              type={showPswd1?"text":"password"}
                              name="CNueva"
                              className="rounded-md border-white shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm  basis-11/12"
                            ></Field>
                            <div className="ml-2 mt-2 hover:text-secundario">
                            {showPswd1 ? (
                              <EyeSlashIcon
                                className=" w-6 h-6 basis-1/12"
                                onClick={()=>togglePswd1()}
                              />
                            ) : (
                              <EyeIcon
                                className="w-6 h-6 basis-1/12"
                                onClick={()=>togglePswd1()}
                              />
                            )}
                          </div>
                          {errors?.CNueva && (
                            <>
                              <div className="grid col-span-1"></div>
                              <div className=" text-sm font-medium text-secundario">
                                {errors?.CNueva}
                              </div>
                            </>
                          )}
                            </div>

                          <label
                            field="CNueva2"
                            className="grid   text-white"
                          >
                            Contraseña Nueva
                          </label>


                          <div className=" bg-white rounded-md  flex flex-row shadow-sm focus:border-secundario focus:ring-secundario">
                            <Field
                              onChange={(e) =>
                                handleLocal(e, setFieldValue, 3, errors)
                              }
                              onBlur={(e) => {
                                handleBlur(e, 3, values);
                              }}
                              type={showPswd2?"text":"password"}
                              name="CNueva2"
                              className=" rounded-md border-white shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm flex basis-11/12"
                            ></Field>
                            <div className="ml-2 mt-2 hover:text-secundario">
                            {showPswd2 ? (
                              <EyeSlashIcon
                                className=" w-6 h-6 basis-1/12 "
                                onClick={()=>togglePswd2()}
                              />
                            ) : (
                              <EyeIcon
                                className="  w-6 h-6 basis-1/12 "
                                onClick={()=>togglePswd2()}
                              />
                            )}

                            </div>
                          </div>
                          {errors?.CNueva2 && (
                            <>
                              <div className="grid col-span-1"></div>
                              <div className="grid col-span-3 text-sm font-medium text-secundario">
                                {errors?.CNueva2}
                              </div>
                            </>
                          )}
                          {/* Boton para guardar */}
                          <div className="mt-2 grid  col-span-4 ">
                            <button
                              type="button"
                              onClick={() => submit(values, errors, 7)}
                              className="ml-auto rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                            >
                              Cambiar
                            </button>
                          </div>
                        </div>

                        <div className="p-6">
                          <CambioConInstrucciones
                            color1={colors.color1}
                            color2={colors.color2}
                            color3={colors.color3}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="basis-1/4 "></div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Container>
      </Layout>
    </>
  );
};
